import $http from './index.js';
export const GetMatchTime= (data)=>{
    return $http.post('api/Match/GetMatchTime',data);
}
export const SaveMatchTime= (data)=>{
    return $http.post('api/Match/SaveMatchTime',data);
}
export const GetMatchList= (data)=>{
    return $http.post('api/Match/GetMatchList',data);
}

